import { Text, Tooltip } from '@radix-ui/themes';
import { Cpu } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const AiDetectionIcon = ({ iconSize = 24, tooltipText }: { iconSize?: number; tooltipText?: string }) => {
  const { t } = useTranslation();
  const effectiveTooltip = tooltipText ?? t('aiDetection.tooltipDefault');
  const fontSize = iconSize * 0.65;

  return (
    <Tooltip content={<Text size="3">{effectiveTooltip}</Text>}>
      <div style={{ position: 'relative', display: 'inline-flex' }}>
        <Cpu className="text-yellow-500" size={iconSize} fill="#ffc107" />
        <span
          style={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            fontSize: `${fontSize}px`,
            color: 'white',
          }}
        >
          AI
        </span>
      </div>
    </Tooltip>
  );
};
export default AiDetectionIcon;
